<template>
  <div class="empty-container">
    <img src="../assets/img/down.png" alt="服务已到期" class="empty-image" />
    <div class="message-primary">抱歉，服务已到期</div>
    <div class="message-secondary">您查看的内容已下架啦~</div>
  </div>
</template>

<script>
export default {
  name: 'Empty'
}
</script>

<style scoped>
.empty-container {
  position: relative;
  width: 750px;
  height: 1000px; /* 高度可以根据页面需要自行调整 */
  margin: 0 auto;
  font-family: "PingFang SC", sans-serif;
  text-align: center;
}

.empty-image {
  position: absolute;
  top: 446px;
  left: 308px;
  width: 134px;
  height: 134px;
}

.message-primary {
  position: absolute;
  top: 446px + 134px + 50px; /* 即630px */
  top: 630px;
  width: 100%;
  font-size: 36px;
  color: #333;
}

.message-secondary {
  position: absolute;
  top: 630px + 36px + 30px; /* 粗略估算行高为36px */
  top: 696px;
  width: 100%;
  font-size: 28px;
  color: #999;
}
</style>
